import { Injectable } from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {Observable} from 'rxjs';
import {environment} from '../../environments/environment';
@Injectable({
  providedIn: 'root'
})
export class NodeService {

  constructor(private http: HttpClient) { }

  ReadAllNode(otp): Observable<any> {
    return this.http.post<number>(`${environment.apiIotUrl}/node/read/all`, {otp: otp});
  }

  UpdateNode(params): Observable<any> {
   return this.http.post<any>(`${environment.apiIotUrl}/node/update`, params);
  }
}
